/*Distribution Statement B. Distribution authorized to U.S. Government agencies only.PavCon,
LLC Proprietary.All rights reserved.
   2020 WARNING: this file may contain export controlled information.*/

import { AppEffects } from './app.effects';
import { AppParamsEffects } from './app-param.effects';
import { AppUserEffects } from './app-user.effects';
import { RulesEffects } from './rules-engine.effects';
import { ConveyorAdminEffects } from './conveyor-admin.effects';
import { AuthEffects } from './user.effects';

export const effects: any[] = [AppEffects, AppParamsEffects, AppUserEffects, RulesEffects, ConveyorAdminEffects, AuthEffects];
/*Distribution Statement B. Distribution authorized to U.S. Government agencies only.PavCon, LLC Proprietary.All rights reserved.
   2020 WARNING: this file may contain export controlled information.*/
